<nz-modal
  nzVisible="true"
  [nzTitle]="modalTitle"
  (nzOnCancel)="cancelAction()"
  (nzOnOk)="submitAction()"
  [nzOkText]="submitBtnText"
  [nzOkDanger]="submitBtnDanger"
  [nzOkDisabled]="submitBtnDisabled"
  [nzOkLoading]="isSubmitInProgress"
  [nzCancelDisabled]="isSubmitInProgress"
  [nzClosable]="!isSubmitInProgress"
  nzMaskClosable="false"
>
  <ng-container *nzModalContent>
    <p>Generate the Income Plan report (in PDF) for this client.</p>

    <ng-container *ngIf="showSubmitFailErrorMessage && submitFailErrorMessage">
      <nz-alert
        nzType="error"
        [nzMessage]="submitFailErrorMessage"
        nzShowIcon
      ></nz-alert>
    </ng-container>
  </ng-container>
</nz-modal>
